import { getPaymentsBillingManagerLocations, useMerchants } from '@frontend/payments-hooks';
import { ModalControlModalProps, useModalControl } from '@frontend/design-system';
import { useStripeOnboarding } from '../hooks';
import { CreationCheckModal } from './creation-check-modal';
import { TermsAndConditionsModal } from './legal-modal';
import { RoleRequiredModal } from './role-required-modal';

type CreateAndTermsConditionModalProps = {
  businessType: string;
  creationCheckModalProps: ModalControlModalProps;
  refetchQueries?: boolean;
  locationId: string | undefined;
};
export const CreateAndTermsConditionModal = ({
  businessType,
  creationCheckModalProps,
  refetchQueries,
  locationId,
}: CreateAndTermsConditionModalProps) => {
  const { activeProcessor, refetch } = useMerchants(locationId)['firstLocation'];
  const { isPaymentsBillingManager } = getPaymentsBillingManagerLocations({
    locationIds: locationId ? [locationId] : [],
  });

  const {
    modalProps: legalTermsModalProps,
    triggerProps: legalTermsTriggerProps,
    closeModal: legalTermsCloseModal,
  } = useModalControl({
    disableReturnFocus: true,
  });
  const { onClick: openLegalModal } = legalTermsTriggerProps;

  const { modalProps: roleRequiredModalProps, triggerProps: roleRequiredTriggerProps } = useModalControl({
    disableReturnFocus: true,
  });

  const { onCreateAccountClick, onContinueOnboardClick } = useStripeOnboarding({
    locationId: locationId || '',
    onCreateError: legalTermsCloseModal,
    onRedirect: legalTermsCloseModal,
    refetch: refetchQueries ? refetch : undefined,
  });

  const handleCreationCheckModal = () => {
    creationCheckModalProps.onClose();
    openLegalModal();
  };

  const handleCreateAccount = ({ setLoading }: { setLoading: (loading: boolean) => void }) => {
    if (isPaymentsBillingManager) {
      if (!activeProcessor?.stripeId) {
        onCreateAccountClick({ businessType, setLoading });
      } else {
        onContinueOnboardClick({ stripeId: activeProcessor?.stripeId, setLoading });
      }
    } else {
      roleRequiredTriggerProps.onClick();
    }
  };

  return (
    <>
      <CreationCheckModal onAccept={handleCreationCheckModal} modalProps={creationCheckModalProps} />
      <TermsAndConditionsModal onAccept={handleCreateAccount} modalProps={legalTermsModalProps} />
      <RoleRequiredModal roleRequiredModalProps={roleRequiredModalProps} />
    </>
  );
};
